import Collection from '@/components/Collection'
import CreateContact from '@/pages/contact/CreateForm'
import ViewContact from '@/pages/contact/Detail'
import UpdateContact from '@/pages/contact/Update'
import DeleteContact from '@/pages/contact/DeleteForm'

export default {

  'contact.collection': {
    path: '/admin/contacts',
    name: 'contact.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listContacts",
      entity: "contact",
      cols: [
        { label: "ID", sort: "id", field: "id" },
        { label: "Contact ID", sort: "cid", field: "contactid" },
        { label: "Organization", sort: "org", field: "org" },
        { label: "Name", sort: "name", field: "name" },
        { label: "Country", sort: "country", field: "country", flag: true },
        { label: "Email", sort: "email", field: "email" },
        { label: "Status", html: (row) => row.status.join('<br>') },
        { label: "IDNum", sort: "idnum", field: "idnum" },
        { label: "VAT", sort: "vat", field: "vat" },
      ],
      actions: (row) => {
        return [
          { name: "contact.view", label: "view", icon: "eye", params: {id: row.id} },
          { name: "contact.update", label: "edit", icon: "pencil2", params: {id: row.id} },
          { name: "contact.delete", label: "delete", icon: "bin", params: {id: row.id} },
        ];
      }
    },
    meta: {
      title: "Contact list",
      side_menu: { label: "Contacts",  icon: "address-book" },
      local_actions: [
        { name: "contact.create", label: "Create contact", color: "success", icon: "plus" }
      ]
    },
  },

  'contact.create': {
    path: '/admin/contacts/create',
    name: 'contact.create',
    component: CreateContact,
    meta: {
      title: "Create new contact"
    },
  },

  'contact.view': {
    path: '/admin/contacts/view/:id',
    name: 'contact.view',
    component: ViewContact,
    props: (route) => {
      return {
        id: Number(route.params.id),
      }
    },
    meta: {
      title: "Contact details",
      local_tasks: [
        { name: "contact.view", label: "View"},
        { name: "contact.update", label: "Edit"},
        { name: "contact.delete", label: "Delete"}
      ]
    },
  },

  'contact.update': {
    path: '/admin/contacts/edit/:id',
    name: 'contact.update',
    component: UpdateContact,
    props: (route) => {
      return {
        id: Number(route.params.id),
      }
    },
    meta: {
      title: "Update contact details",
      local_tasks: [
        { name: "contact.view", label: "View"},
        { name: "contact.update", label: "Edit"},
        { name: "contact.delete", label: "Delete"}
      ]
    },
  },

  'contact.delete': {
    path: '/admin/contacts/delete/:id',
    name: 'contact.delete',
    component: DeleteContact,
    props: (route) => {
      return {
        id: Number(route.params.id),
      }
    },
    meta: {
      title: "Delete contact",
      local_tasks: [
        { name: "contact.view", label: "View"},
        { name: "contact.update", label: "Edit"},
        { name: "contact.delete", label: "Delete"}
      ]
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/contact.js